'use client'
import { Product } from '@/features/product/model/product.model'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { ProductList } from '../productList'
import { ROUTES } from '@/core/constants/routes'
import { use } from 'react'

type Props = {
  products: Product[] | Promise<Product[]>
}
export function PopularProducts({ products }: Props) {
  const t = useTranslations()

  const productsList = products instanceof Promise ? use(products) : products
  return (
    <section className='my-10'>
      <div className='mb-1 flex items-center justify-between px-5'>
        <h2 className='mb-3 text-xl font-semibold'>
          {t('products.popularProducts')}
        </h2>
        <Link
          href={ROUTES.search}
          className='text-creamed-cron mb-3 text-sm font-bold'
        >
          {t('actions.viewAll')}
        </Link>
      </div>
      <div className='mx-auto'>
        <ProductList products={productsList} />
      </div>
    </section>
  )
}
